import React, { Component } from "react";
import { Card, Button, Form, Alert } from "react-bootstrap";
import axios from 'axios'


export default class SalaryDetails extends Component {

  constructor(props) {
    super(props)

    this.state = {
      departmentsForSalary: [],
      selectedDepartmentForSalary: null,
      selectedUserForSalary: null,
      financialId: null,
      users: [],
      salaryBasic: 0,
      allowanceHouseRent: 0,
      allowanceMedical: 0,
      allowanceSpecial: 0,
      allowanceFuel: 0,
      allowancePhoneBill: 0,
      allowanceOther: 0,
      deductionTax: 0,
      deductionOther: 0,
      hasError: false,
      errMsg: "",
      completed: false
    }
  }

  componentDidMount() {
    console.log("selectedUserForSalary", this.props.location.state.selectedUser);
    axios({
      method: 'get',
      url: '/departments',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        this.setState({ departmentsForSalary: res.data }, () => {
          if (this.props.location.state) {
            this.setState({ selectedDepartmentForSalary: this.props.location.state?.selectedUser?.departmentId }, () => {
              // this.setState({ selectedDepartmentForSalary: this.props.location.state?.selectedUserForSalary?.departmentId }, () => {
              this.fetchDataForSalary()
            })
            this.setState({ selectedUserForSalary: this.props.location.state?.selectedUser?.id }, () => {
              // this.setState({ selectedUserForSalary: this.props.location.state?.selectedUserForSalary?.id }, () => {
              this.pushChangesForSalary()
            })
          }
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  pushChangesForSalary = () => {
    axios({
      method: 'get',
      url: 'financialInformations/user/' + this.state.selectedUserForSalary,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        this.setState(prevState => ({
          ...prevState,
          financialId: res.data[0].id,
          ...res.data[0]
        }))
      })
      .catch(err => {
        console.log(err)
      })
  }

  fetchDataForSalary = () => {
    axios({
      method: 'get',
      url: 'departments/' + this.state.selectedDepartmentForSalary,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        let department = res.data
        let users = [];

        department?.users?.map(user => {
          users.push(user)
        })

        this.setState({ users: users })
      })
      .catch(err => {
        console.log(err)
      })
  }

  fetchDataAll = () => {
    axios({
      method: 'get',
      url: 'departments/',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        let departmentsData = res.data
        let users = [];

        departmentsData.map(dept => {
          dept.users.map(user => {
            users.push(user)
          })
        })

        this.setState({ users: users })
      })
      .catch(err => {
        console.log(err)
      })
  }

  pushDepartmentsForSalary = () => {
    let items = []
    items.push(<option key={584390} value="all">All departments</option>)
    this.state.departmentsForSalary.map((dept, index) => {
      if (this.state.selectedDepartmentForSalary == dept.id) {
        items.push(<option key={index} value={dept.id} defaultValue>{dept.departmentName}</option>)
      } else {
        items.push(<option key={index} value={dept.id}>{dept.departmentName}</option>)
      }
    })
    return items
  }

  pushUsersForSalary = () => {
    let items = []

    this.state.users.map((user, index) => {
      items.push(<option key={index} value={user.id}>{user.fullName}</option>)
    })

    return items
  }

  handleDepartmentChangeForSalary = (event) => {
    this.setState({ selectedDepartmentForSalary: event.target.value }, () => {
      if (this.state.selectedDepartmentForSalary === "all") {
        this.fetchDataAll()
      } else {
        this.fetchDataForSalary()
      }
    })
  }

  handleUserChangeForSalary = (event) => {
    this.state.users.map(user => {
      if (user.id == event.target.value) {
        this.setState({ selectedUserForSalary: event.target.value }, () => {
          axios({
            method: 'get',
            url: 'financialInformations/user/' + this.state?.selectedUserForSalary,
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
          })
            .then(res => {
              this.setState(prevState => ({
                ...prevState,
                financialId: res.data[0].id,
                ...res.data[0]
              }))
            })
            .catch(err => {
              console.log(err)
            })
        })
      }
    })
  }

  handleChangeEmploymentType = (event) => {
    const { name, value } = event.target
    this.setState({
      [name]: value
    })
  }

  handleChangeForSalary = (event) => {
    const { name, value } = event.target
    this.setState({
      [name]: +value
    })
  }

  onSubmitForSalary = (event) => {
    event.preventDefault()

    let data = {
      employmentType: this.state.employmentType,
      salaryBasic: this.state.salaryBasic,
      salaryGross: this.salaryGross,
      salaryNet: this.salaryNet,
      allowanceHouseRent: this.state.allowanceHouseRent,
      allowanceMedical: this.state.allowanceMedical,
      allowanceSpecial: this.state.allowanceSpecial,
      allowanceFuel: this.state.allowanceFuel,
      allowancePhoneBill: this.state.allowancePhoneBill,
      allowanceOther: this.state.allowanceOther,
      allowanceTotal: this.state.allowanceHouseRent + this.state.allowanceMedical + this.state.allowanceSpecial +
        this.state.allowanceFuel + this.state.allowancePhoneBill + this.state.allowanceOther,
      deductionTax: this.state.deductionTax,
      deductionOther: this.state.deductionOther,
      deductionTotal: this.state.deductionTax + this.state.deductionOther,
      salaryGross: this.state.salaryBasic + this.state.allowanceHouseRent +
        this.state.allowanceMedical + this.state.allowanceSpecial +
        this.state.allowancePhoneBill + this.state.allowanceFuel +
        this.state.allowanceOther,
      salaryNet: this.state.salaryBasic + this.state.allowanceHouseRent +
        this.state.allowanceMedical + this.state.allowanceSpecial +
        this.state.allowancePhoneBill + this.state.allowanceFuel +
        this.state.allowanceOther - this.state.deductionTax - this.state.deductionOther
    }

    axios({
      method: 'put',
      url: 'financialInformations/' + this.state.financialId,
      data: data,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        this.setState({ completed: true })
        window.scrollTo(0, 0)
      })
      .catch(err => {
        this.setState({ hasError: true, errMsg: err.response.data.message })
        window.scrollTo(0, 0)
      })
  }

  onEdit(job) {
    return event => {
      event.preventDefault()
      this.setState({ selectedJob: job, showEditModel: true })
    }
  }

  handleBackToSalaryList = () => {
    this.props.history.push('/salary-list')
  }

  render() {

    let salaryGross = this.state.salaryBasic + this.state.allowanceHouseRent +
      this.state.allowanceMedical + this.state.allowanceSpecial +
      this.state.allowancePhoneBill + this.state.allowanceFuel +
      this.state.allowanceOther

    let deductionTotal = this.state.deductionTax + this.state.deductionOther

    let salaryNet = salaryGross - deductionTotal

    return (
      <div className="container-fluid pt-2">
        <div className="row">

          {this.state.hasError ? (
            <Alert variant="outline-danger" className="m-3" block>
              {this.state.errMsg}
            </Alert>
          ) :
            this.state.completed ? (
              <Alert variant="outline-success" className="m-3" block>
                Financial Infromation have been updated.
              </Alert>
            ) : (<></>)}

          <div className="col-sm-12">
            <Card className="main-card">
              <Card.Header><div>Manage Salary Details</div></Card.Header>
              <Card.Body>
                <Card.Text>
                  <Form onSubmit={this.onSubmitForSalary}>
                    <Form.Group>
                      <Form.Label className="required">Select Department </Form.Label>
                      <Form.Control
                        as="select"
                        className="select-css"
                        value={this.state.selectedDepartmentForSalary}
                        onChange={this.handleDepartmentChangeForSalary}
                      >
                        <option key={34432432} value="">Choose one...</option>
                        {this.pushDepartmentsForSalary()}
                      </Form.Control>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label className="required">Select User </Form.Label>
                      <Form.Control
                        as="select"
                        className="select-css"
                        value={this.state.selectedUserForSalary || ''}
                        onChange={this.handleUserChangeForSalary}
                      >
                        <option value="">Choose one...</option>
                        {this.pushUsersForSalary()}
                      </Form.Control>
                    </Form.Group>
                  </Form>
                </Card.Text>
              </Card.Body>
            </Card>
          </div>
        </div>
        {this.state.selectedUserForSalary ? (
          <Form onSubmit={this.onSubmitForSalary}>
            <div className="row">
              <div className="col-sm-6">
                <Card className="main-card">
                  <Card.Header>Salary Details</Card.Header>
                  <Card.Body>
                    <Card.Text>
                      <Form.Group>
                        <Form.Label className="required">Employment Type </Form.Label>
                        <Form.Control
                          as="select"
                          className="select-css"
                          value={this.state.employmentType}
                          onChange={this.handleChangeEmploymentType}
                          name="employmentType"
                        >
                          <option value="">Choose one...</option>
                          <option value="Full Time">Full Time</option>
                          <option value="Part Time">Part Time</option>
                        </Form.Control>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label className="required">Basic Salary</Form.Label>
                        <Form.Control
                          type="number"
                          value={this.state.salaryBasic}
                          onChange={this.handleChangeForSalary}
                          name="salaryBasic"
                        />
                      </Form.Group>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>
              <div className="col-sm-6">
                <Card className="main-card">
                  <Card.Header><div style={{ padding: '11px' }}></div></Card.Header>
                  <Card.Body>
                    <Card.Text>

                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-6">
                <Card className="main-card">
                  <Card.Header>Allowances</Card.Header>
                  <Card.Body>
                    <Card.Text>
                      <Form.Group>
                        <Form.Label>House Rent Allowance</Form.Label>
                        <Form.Control
                          type="number"
                          value={this.state.allowanceHouseRent}
                          onChange={this.handleChangeForSalary}
                          name="allowanceHouseRent"
                        />
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Medical Allowance</Form.Label>
                        <Form.Control
                          type="number"
                          value={this.state.allowanceMedical}
                          onChange={this.handleChangeForSalary}
                          name="allowanceMedical"
                        />
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Special Allowance</Form.Label>
                        <Form.Control
                          type="number"
                          value={this.state.allowanceSpecial}
                          onChange={this.handleChangeForSalary}
                          name="allowanceSpecial"
                        />
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Fuel Allowance</Form.Label>
                        <Form.Control
                          type="number"
                          value={this.state.allowanceFuel}
                          onChange={this.handleChangeForSalary}
                          name="allowanceFuel"
                        />
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Phone Bill Allowance</Form.Label>
                        <Form.Control
                          type="number"
                          value={this.state.allowancePhoneBill}
                          onChange={this.handleChangeForSalary}
                          name="allowancePhoneBill"
                        />
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Other Allowance</Form.Label>
                        <Form.Control
                          type="number"
                          value={this.state.allowanceOther}
                          onChange={this.handleChangeForSalary}
                          name="allowanceOther"
                        />
                      </Form.Group>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>
              <div className="col-sm-6">
                <div className="row">
                  <div className="col-sm-12">
                    <Card className="main-card">
                      <Card.Header>Deductions</Card.Header>
                      <Card.Body>
                        <Card.Text>
                          <Form.Group>
                            <Form.Label>Tax Deduction</Form.Label>
                            <Form.Control
                              type="number"
                              value={this.state.deductionTax}
                              onChange={this.handleChangeForSalary}
                              name="deductionTax"
                            />
                          </Form.Group>
                          <Form.Group>
                            <Form.Label>Other Deduction</Form.Label>
                            <Form.Control
                              type="number"
                              value={this.state.deductionOther}
                              onChange={this.handleChangeForSalary}
                              name="deductionOther"
                            />
                          </Form.Group>
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <Card className="main-card">
                      <Card.Header>Total Salary Details</Card.Header>
                      <Card.Body>
                        <Card.Text>
                          <Form.Group>
                            <Form.Label>Gross Salary</Form.Label>
                            <Form.Control
                              type="number"
                              value={salaryGross}
                              readOnly
                            />
                          </Form.Group>
                          <Form.Group>
                            <Form.Label>Total Deductions</Form.Label>
                            <Form.Control
                              type="number"
                              value={deductionTotal}
                              readOnly
                            />
                          </Form.Group>
                          <Form.Group>
                            <Form.Label>Net Salary</Form.Label>
                            <Form.Control
                              type="number"
                              value={salaryNet}
                              readOnly
                            />
                          </Form.Group>
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-md-6">
                    <Button type="submit" block>Submit</Button>
                  </div>
                  <div className="col-md-6">
                    <Button type="button" variant="outline-danger" block onClick={this.handleBackToSalaryList}>Cancel</Button>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        ) : null}
      </div>
    );
  }
}